import { render, staticRenderFns } from "./WizardTituloItem.vue?vue&type=template&id=a031621c&"
import script from "./WizardTituloItem.vue?vue&type=script&lang=js&"
export * from "./WizardTituloItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports